import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-2 mt-2 lg:mt-0 rounded shadow bg-white" }
const _hoisted_2 = { class: "p-6" }
const _hoisted_3 = { class: "text-xl font-bold" }
const _hoisted_4 = { class: "pt-2 text-gray-600 text-xs lg:text-sm flex items-center justify-center lg:justify-start" }
const _hoisted_5 = { class: "p-2 mt-2 rounded shadow bg-white mt-2" }
const _hoisted_6 = { class: "p-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2" }, "解答", -1)
const _hoisted_8 = { class: "p-6" }
const _hoisted_9 = { class: "mb-2 last:mb-0" }
const _hoisted_10 = { class: "grid grid-cols-1 gap-3 mb-4" }
const _hoisted_11 = { class: "relative" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2" }, [
  /*#__PURE__*/_createTextVNode("返信メッセージ"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs align-text-top text-red-600 ml-2" }, "必須")
], -1)
const _hoisted_13 = {
  key: 0,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_14 = { class: "relative" }
const _hoisted_15 = { class: "block mb-2" }
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = {
  key: 1,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_18 = { class: "relative" }
const _hoisted_19 = { class: "block mb-2" }
const _hoisted_20 = ["placeholder"]
const _hoisted_21 = {
  key: 2,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_22 = { class: "relative" }
const _hoisted_23 = { class: "block mb-2" }
const _hoisted_24 = ["placeholder"]
const _hoisted_25 = {
  key: 3,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_26 = { class: "relative" }
const _hoisted_27 = { class: "block mb-2" }
const _hoisted_28 = ["placeholder"]
const _hoisted_29 = {
  key: 4,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_30 = { class: "relative" }
const _hoisted_31 = { class: "block mb-2" }
const _hoisted_32 = ["placeholder"]
const _hoisted_33 = {
  key: 5,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_34 = { class: "relative" }
const _hoisted_35 = { class: "block mb-2" }
const _hoisted_36 = ["placeholder"]
const _hoisted_37 = {
  key: 6,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_38 = { class: "relative" }
const _hoisted_39 = { class: "block mb-2" }
const _hoisted_40 = ["placeholder"]
const _hoisted_41 = {
  key: 7,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_42 = { class: "relative" }
const _hoisted_43 = { class: "block mb-2" }
const _hoisted_44 = ["placeholder"]
const _hoisted_45 = {
  key: 8,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_46 = { class: "relative" }
const _hoisted_47 = { class: "block mb-2" }
const _hoisted_48 = ["placeholder"]
const _hoisted_49 = {
  key: 9,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_50 = { class: "relative" }
const _hoisted_51 = { class: "block mb-2" }
const _hoisted_52 = ["placeholder"]
const _hoisted_53 = {
  key: 10,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_54 = { class: "relative" }
const _hoisted_55 = { class: "block mb-2" }
const _hoisted_56 = ["placeholder"]
const _hoisted_57 = {
  key: 11,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_58 = { class: "relative" }
const _hoisted_59 = { class: "block mb-2" }
const _hoisted_60 = ["placeholder"]
const _hoisted_61 = {
  key: 12,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_62 = { class: "relative" }
const _hoisted_63 = { class: "block mb-2" }
const _hoisted_64 = ["placeholder"]
const _hoisted_65 = {
  key: 13,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_66 = { class: "relative" }
const _hoisted_67 = { class: "block mb-2" }
const _hoisted_68 = ["placeholder"]
const _hoisted_69 = {
  key: 14,
  class: "grid grid-cols-1 gap-3 mt-2"
}
const _hoisted_70 = { class: "relative" }
const _hoisted_71 = { class: "block mb-2" }
const _hoisted_72 = ["placeholder"]

import moment from "moment";
import Salon from "@/models/Salon";
import JackRequest from "@/models/JackRequest";
import JackReplyment from "@/models/JackReplyment";
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
// // import Shop from "@/models/Shop";
// // import Staff from "@/models/Staff";

// interface JackRequestDetailState {
//   // is_loading: boolean;

//   request: JackRequest;
//   salon: Salon;
//   replyment: JackReplyment;
// }

// export default defineComponent({
//   data() {
//     return {
//       // is_loading: false,


export default /*#__PURE__*/_defineComponent({
  __name: 'JackResponseDetail',
  setup(__props) {

// import { defineComponent } from "vue";
const store = useStore();
const route = useRoute();
const router = useRouter();

const request = ref<JackRequest>({} as JackRequest);
const salon = ref<Salon>({} as Salon);
const replyment = ref<JackReplyment>({} as JackReplyment);
//     } as JackRequestDetailState;
//   },

//   computed: {
const is_system = computed<boolean>(() => {
  return store.state.role == "system";
});

const is_salon = computed<boolean>(() => {
  return !!store.state.salon_id;
});

const salon_id = computed<string | null>(() => {
  return store.state.salon_id;
});
//   },

//   mounted() {
//     console.log("a");
//     refresh();
//   },

onMounted(() => {
  console.log("a");
  refresh();
});

//   methods: {
const formatDate = (date: Date, format: string) => {
  return moment(date).format(format);
};

const refresh = () => {
  if (store.state.is_loading) {
    return;
  }

  store.dispatch("setLoading", true);

  console.log(route);
  const request_id = route.params.jack_request_id as string;
  const salon_id = route.params.salon_id as string;

  setTimeout(async () => {
    try {
      request.value = await JackRequest.get(request_id);
      salon.value = await Salon.get(salon_id);
      replyment.value = (await JackReplyment.get(
        request_id,
        salon_id
      )) as JackReplyment;
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};
//   },
// });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(request.value.title), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(`${request.value.article}`), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h5", null, _toDisplayString(salon.value.name), 1),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800",
                  placeholder: "返信メッセージ",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((replyment.value.replyment_body) = $event)),
                  disabled: ""
                }, null, 512), [
                  [_vModelText, replyment.value.replyment_body]
                ])
              ])
            ]),
            (!!request.value.condition1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("label", _hoisted_15, _toDisplayString(request.value.condition1), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800",
                      placeholder: request.value.condition1,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((replyment.value.answer1) = $event)),
                      disabled: ""
                    }, null, 8, _hoisted_16), [
                      [_vModelText, replyment.value.answer1]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!!request.value.condition2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("label", _hoisted_19, _toDisplayString(request.value.condition2), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800",
                      placeholder: request.value.condition2,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((replyment.value.answer2) = $event)),
                      disabled: ""
                    }, null, 8, _hoisted_20), [
                      [_vModelText, replyment.value.answer2]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!!request.value.condition3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("label", _hoisted_23, _toDisplayString(request.value.condition3), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800",
                      placeholder: request.value.condition3,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((replyment.value.answer3) = $event)),
                      disabled: ""
                    }, null, 8, _hoisted_24), [
                      [_vModelText, replyment.value.answer3]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!!request.value.condition4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("label", _hoisted_27, _toDisplayString(request.value.condition4), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800",
                      placeholder: request.value.condition4,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((replyment.value.answer4) = $event)),
                      disabled: ""
                    }, null, 8, _hoisted_28), [
                      [_vModelText, replyment.value.answer4]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!!request.value.condition5)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("label", _hoisted_31, _toDisplayString(request.value.condition5), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800",
                      placeholder: request.value.condition5,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((replyment.value.answer5) = $event)),
                      disabled: ""
                    }, null, 8, _hoisted_32), [
                      [_vModelText, replyment.value.answer5]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!!request.value.condition6)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("label", _hoisted_35, _toDisplayString(request.value.condition6), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800",
                      placeholder: request.value.condition6,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((replyment.value.answer6) = $event)),
                      disabled: ""
                    }, null, 8, _hoisted_36), [
                      [_vModelText, replyment.value.answer6]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!!request.value.condition7)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("label", _hoisted_39, _toDisplayString(request.value.condition7), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800",
                      placeholder: request.value.condition7,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((replyment.value.answer7) = $event)),
                      disabled: ""
                    }, null, 8, _hoisted_40), [
                      [_vModelText, replyment.value.answer7]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!!request.value.condition8)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("label", _hoisted_43, _toDisplayString(request.value.condition8), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800",
                      placeholder: request.value.condition8,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((replyment.value.answer8) = $event)),
                      disabled: ""
                    }, null, 8, _hoisted_44), [
                      [_vModelText, replyment.value.answer8]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!!request.value.condition9)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("label", _hoisted_47, _toDisplayString(request.value.condition9), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800",
                      placeholder: request.value.condition9,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((replyment.value.answer9) = $event)),
                      disabled: ""
                    }, null, 8, _hoisted_48), [
                      [_vModelText, replyment.value.answer9]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!!request.value.condition10)
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("label", _hoisted_51, _toDisplayString(request.value.condition10), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800",
                      placeholder: request.value.condition10,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((replyment.value.answer10) = $event)),
                      disabled: ""
                    }, null, 8, _hoisted_52), [
                      [_vModelText, replyment.value.answer10]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!!request.value.condition11)
              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("label", _hoisted_55, _toDisplayString(request.value.condition11), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800",
                      placeholder: request.value.condition11,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((replyment.value.answer11) = $event)),
                      disabled: ""
                    }, null, 8, _hoisted_56), [
                      [_vModelText, replyment.value.answer11]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!!request.value.condition12)
              ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("label", _hoisted_59, _toDisplayString(request.value.condition12), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800",
                      placeholder: request.value.condition12,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((replyment.value.answer12) = $event)),
                      disabled: ""
                    }, null, 8, _hoisted_60), [
                      [_vModelText, replyment.value.answer12]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!!request.value.condition13)
              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("label", _hoisted_63, _toDisplayString(request.value.condition13), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800",
                      placeholder: request.value.condition13,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((replyment.value.answer13) = $event)),
                      disabled: ""
                    }, null, 8, _hoisted_64), [
                      [_vModelText, replyment.value.answer13]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!!request.value.condition14)
              ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("label", _hoisted_67, _toDisplayString(request.value.condition14), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800",
                      placeholder: request.value.condition14,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((replyment.value.answer14) = $event)),
                      disabled: ""
                    }, null, 8, _hoisted_68), [
                      [_vModelText, replyment.value.answer14]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!!request.value.condition15)
              ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("label", _hoisted_71, _toDisplayString(request.value.condition15), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800",
                      placeholder: request.value.condition15,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((replyment.value.answer15) = $event)),
                      disabled: ""
                    }, null, 8, _hoisted_72), [
                      [_vModelText, replyment.value.answer15]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
}
}

})